<template>
    <div class="ReCopyClipboard" >
        <base-button class="btn btn-icon no-border btn-simple btn-success my-0" @click="copy"><i class="tim-icons icon-single-copy-04"></i></base-button>
        <!-- <div @click="copy">В буфер</div> -->
    </div>
</template>
<script>
    export default {
		name: 'ReCopyClipboard',
		components: {

		},
		props: {
			value: String,
            imgClipboard: {
                type: Boolean,
                default: false
            }
        },
        data () {
			return {
				ver: 1,
				
			}
		},
        methods:{
            copy(){
                let imgtag = '';
                if(this.imgClipboard == true){
                    // imgtag = ['<img src="', this.value, '" alt="" class="photoFAQ"><br>'].join('');
                    // console.log(imgtag);
                    imgtag = `<img src="${this.value}" alt="" class="photoFAQ"><br>`;
                    navigator.clipboard.writeText(imgtag);
                    
                }else {
                    navigator.clipboard.writeText(this.value);
                }
                // navigator.clipboard.writeText(this.value);
            }
        }
    }
</script>
<style scoped>

</style>